module.exports = __webpack_public_path__ + "img/office-logo-signup-selection.290aa841.svg";